export const SUFIXBCOINS = ['TUSDB', 'THKDB', 'TGBPB', 'TCADB', 'TAUDB', 'IDRTB', 'BTCB', 'USDSB']

const reduceTradePairBSufix = tradePair => {
  if (!tradePair) return ''
  let [baseAsset, quoteAsset] = tradePair.split('_')
  if (SUFIXBCOINS.find(c => baseAsset?.toUpperCase()?.includes(c))) {
    baseAsset = baseAsset.replace(/B-.+/i, '')
  }

  if (SUFIXBCOINS.find(c => quoteAsset?.toUpperCase()?.includes(c))) {
    quoteAsset = quoteAsset.replace(/B-.+/i, '')
  }

  return quoteAsset
    ? `${baseAsset.replace(/-.+/i, '')}_${quoteAsset.replace(/-.+/i, '')}`
    : baseAsset.replace(/-.+/i, '')
}

export default reduceTradePairBSufix
